<template>
  <div class="my-tags" :class="`active${activeTag}`">
    <div class="tags">
      <div
        class="tags-item"
        v-for="index in 3"
        :key="index"
        @click="changeTag(index - 1)"
      ></div>
    </div>

    <div ref="content" class="content">
      <div
        v-for="index in 3"
        :key="index"
        class="item"
        v-show="activeTag === index - 1"
      >
        <img src="./images/im-bg.png" alt="" v-show="activeTag === 0" />
        <img src="./images/voice-room-bg.png" alt="" v-show="activeTag === 1" />
        <img src="./images/order-bg.png" alt="" v-show="activeTag === 2" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mytags',
  data() {
    return {
      activeTag: 0
    };
  },
  mounted() {
    // this.$refs.content.addEventListener('touchstart', e => {
    //   this.startX = e.touches[0].pageX;
    // });
    // this.$refs.content.addEventListener('touchend', e => {
    //   this.endX = e.changedTouches[0].pageX;
    //   if (this.startX - this.endX > 60) {
    //     this.nextTag();
    //   } else if (this.startX - this.endX < -60) {
    //     this.prevTag();
    //   }
    // });
  },
  methods: {
    changeTag(index) {
      this.activeTag = index;
    },
    nextTag() {
      if (this.activeTag < 2) {
        this.activeTag++;
      } else {
        this.activeTag = 0;
      }
    },
    prevTag() {
      if (this.activeTag > 0) {
        this.activeTag--;
      } else {
        this.activeTag = 2;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-tags {
  width: 642px;
  &.active0 {
    .tags-item {
      &:nth-child(1) {
        height: 103px;
        background: url('./images/tags-im-active.png') no-repeat;
      }
    }
  }
  &.active1 {
    .tags-item {
      &:nth-child(2) {
        height: 103px;
        background: url('./images/tags-voice-room-active.png') no-repeat;
      }
    }
  }
  &.active2 {
    .tags-item {
      &:nth-child(3) {
        height: 103px;
        background: url('./images/tags-order-active.png') no-repeat;
      }
    }
  }
}
.tags {
  display: flex;
  justify-content: space-around;
  padding: 0 23px;
  align-items: flex-end;
  height: 103px;
}
.tags-item {
  cursor: pointer;
  width: 195px;
  height: 88px;
  background-size: 100% !important;
  &:nth-child(1) {
    background: url('./images/tags-im.png') no-repeat;
  }
  &:nth-child(2) {
    background: url('./images/tags-voice-room.png') no-repeat;
  }
  &:nth-child(3) {
    background: url('./images/tags-order.png') no-repeat;
  }
}
.content {
  margin-top: -11px;
  .item {
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
